import React from "react";
import { range, getClass } from "src/utils";
import styles from "./style.css";
import { useStore } from "src/store";
import { SPONSORED_ADS_PROVIDER_IDS } from "../../utils/constants";

const DEFAULT_MAX_RANGE = 5;
const DEFAULT_PAGE_COUNT = 5;

const PaginationWithArrows = props => {
  const { submitSearch, enablePrevPage } = props;
  const store = useStore();
  const search = store("search");
  const p = +search.p;

  const nextPage = p + 1;
  const prePage = p - 1;

  let disableArrowClass = getClass(enablePrevPage ? styles.enableArrow : styles.disableArrow);

  return (
    <ul class={styles.pagination} style={{ marginTop: 10 }}>
      <li
        onClick={() => {
          submitSearch(prePage, "prev");
        }}
        class={disableArrowClass}
      >
        {"<"}
      </li>
      <li
        onClick={() => {
          submitSearch(nextPage, "next");
        }}
        style={{ marginLeft: "unset" }}
      >
        {">"}
      </li>
    </ul>
  );
};

const PaginationWithNumbers = props => {
  const { pageCount = DEFAULT_PAGE_COUNT, maxRange = DEFAULT_MAX_RANGE, submitSearch } = props;
  const store = useStore();
  const search = store("search");
  const p = +search.p;
  let firstPage, lastPage;
  if (maxRange <= pageCount) {
    /*
    This logic keeps track of number of pages to show in the UI (maxRange) vs total number of pages available (pageCount)
    We displace the pages shown depending on the selected page
    If the selected page is smaller or equal to half of the maxRange we set a temporary last page and highlight the page in the middle of the range
    If the selected page is greater than half of the maxRange we displace the highlight of the page to the end of the range
    */
    const differenceBetweenPrePages = (pageCount - p <= Math.floor(maxRange / 2)) ? p - (pageCount - maxRange) : Math.min(p, Math.ceil((maxRange / 2) - 1))
    const differenceBetweenNextPages = maxRange - differenceBetweenPrePages;
    firstPage = p - differenceBetweenPrePages;
    lastPage = p + differenceBetweenNextPages;
  } else {
    firstPage = 0;
    lastPage = pageCount;
  }

  const nextPage = p + 1;
  const prePage = p - 1
  const noMorePages = nextPage === pageCount;

  return (
    <ul class={styles.pagination}>
      {p > 0 && (
        <li
          onClick={() => {
            submitSearch(prePage);
          }}
        >
          {"<"}
        </li>
      )}
      {range(firstPage, lastPage).map(i => (
        <li
          class={getClass(i === p && styles.active)}
          key={i}
          onClick={() => {
            submitSearch(i);
          }}
        >
          {i + 1}
        </li>
      ))}
      {noMorePages ? null : (
        <li
          onClick={() => {
            submitSearch(nextPage, "next");
          }}
        >
          {">"}
        </li>
      )}
    </ul>
  );
};

const Pagination = props => {
  const { pageCount = DEFAULT_PAGE_COUNT, maxRange = DEFAULT_MAX_RANGE, submitSearch, provider, enablePrevPage } = props;


  switch (provider) {
    case SPONSORED_ADS_PROVIDER_IDS.BING.id:
      return <PaginationWithNumbers pageCount={pageCount} maxRange={maxRange} submitSearch={(...props) => submitSearch(...props)} />;
    case SPONSORED_ADS_PROVIDER_IDS.YAHOO_SYNDICATION.id:
      return <PaginationWithArrows submitSearch={(...props) => submitSearch(...props)} enablePrevPage={enablePrevPage} />;
    default:
      return <PaginationWithNumbers pageCount={pageCount} maxRange={maxRange} submitSearch={(...props) => submitSearch(...props)} />;
  }
};
export default Pagination;
